<template>
  <v-row justify="center">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">
          <v-icon left>mdi-create</v-icon>Ajouter nouvelle expérience
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Expérience</span>
        </v-card-title>
        <v-card-text class="py-0">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  color="secondary"
                  label="Expérience"
                  outlined
                  counter
                  :error-messages="labelErrors"
                  v-model="label"
                  @input="$v.label.$touch()"
                  @blur="$v.label.$touch()"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  color="secondary"
                  label="Où"
                  placeholder="Où vous avez eu cette expérience"
                  hint="exemple: salle de sport &#34;XXXXX&#34; "
                  outlined
                  :error-messages="hostErrors"
                  @input="$v.host.$touch()"
                  @blur="$v.host.$touch()"
                  v-model="host"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Description (optionnel)"
                  color="secondary"
                  outlined
                  hint="quelques mot sur votre expérience"
                  v-model="expDescription"
                  counter
                  :error-messages="expDescriptionErrors"
                  @input="$v.expDescription.$touch()"
                  @blur="$v.expDescription.$touch()"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  type="Number"
                  label="Durée"
                  hint="en année"
                  color="secondary"
                  outlined
                  v-model="duration"
                  suffix="an(s)"
                  :error-messages="durationErrors"
                  @input="$v.duration.$touch()"
                  @blur="$v.duration.$touch()"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="primary darken-1" outlined @click="dialog = false">Fermer</v-btn>
          <v-btn color="blue darken-1" text @click="save">Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    label: { required, minLength: minLength(5) },
    host: { required, minLength: minLength(5) },
    expDescription: { minLength: minLength(10) },
    duration: { required, minValue: minValue(1) }
  },
  computed: {
    ...mapGetters({ user: "user", loading: "loading" }),
    labelErrors() {
      const errors = [];
      if (!this.$v.label.$dirty) return errors;
      !this.$v.label.minLength &&
        errors.push("Ce nécissite plus de 5 caractéres");
      !this.$v.label.required && errors.push("Ce champ est obligatoire.");
      return errors;
    },
    hostErrors() {
      const errors = [];
      if (!this.$v.host.$dirty) return errors;
      !this.$v.host.required && errors.push("Ce champ est obligatoire.");
      !this.$v.host.minLength &&
        errors.push("Ce nécissite plus de 5 caractéres");
      return errors;
    },
    expDescriptionErrors() {
      const errors = [];
      if (!this.$v.expDescription.$dirty) return errors;
      !this.$v.expDescription.minLength &&
        errors.push("la description doit être 10 caractére au minimum.");
      return errors;
    },
    durationErrors() {
      const errors = [];
      if (!this.$v.duration.$dirty) return errors;
      !this.$v.duration.minValue && errors.push("la durée ne doit pas être 0.");
      !this.$v.duration.required && errors.push("Ce champ est obligatoire.");
      return errors;
    }
  },
  data: () => ({
    label: "",
    host: "",
    expDescription: "",
    duration: "",
    dialog: false
  }),
  methods: {
    ...mapActions(["saveExperience"]),
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.saveExperience({
          label: this.label,
          host: this.host,
          expDescription: this.expDescription,
          duration: this.duration
        });
        this.dialog = false;
      }
    }
  }
};
</script>